import { createFileRoute } from '@tanstack/react-router'
import { UnansweredQuestionsScreen } from './-components/unanswered-questions-screen.tsx'

export const Route = createFileRoute('/engineering/unanswered-questions')({
  component: UnansweredQuestionsScreen
})
